import styled, { css } from 'styled-components';
import SearchBar from '@bitcoin-portal/bitcoincom-pkg-components/dist/SearchBar';
import { media } from '@bitcoin-portal/bitcoincom-pkg-theme';

interface VideoProps {
  display: string;
}

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  background: #ffffff;
  width: 100%;
  height: auto;
  position: fixed;
  padding: 0px;
  top: 0;
  left: 0;
  z-index: 99999;
`;

export const Content = styled.div`
  width: 100%;
  max-width: 1440px;
  padding: 0px !important;
  margin: 20px auto;
`;

export const NavbarContainer = styled.div`
  padding: 0px 20px;

  ${media.md`
    padding: 0px 60px;
  `}

  ${media.xl`
    padding: 0px 80px;
  `}
`;

export const NavbarWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const LogoLink = styled.a`
  height: 40px;
  cursor: pointer;

  ${media.md`
    height: auto;
  `}

  ${media.xl`
    height: auto;
  `}
`;

export const LogoWrapper = styled.span`
  display: flex;
  align-items: center;
`;

export const LogoImageWrapper = styled.div`
  width: 190px;
  height: 40px;

  ${media.md`
    display: flex;
    width: 228px;
    height: auto;
  `}

  ${media.xl`
    width: 238px;
    height: auto;
  `}

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const Video = styled.video<VideoProps>`
  display: ${props => props.display || 'block'};
  width: 190px;
  height: 40px;
  object-fit: contain;
  vertical-align: middle;
  background-color: transparent !important;

  ${media.md`
    width: 228px;
    height: auto;
    vertical-align: unset;
  `}

  ${media.xl`
    width: 238px;
    height: auto;
  `}
`;

export const ItemsContainer = styled.div`
  display: none;
  justify-content: center;
  align-items: start;
  background: #1c1c1c;
  width: fit-content;
  margin: 0px auto;
  padding: 10px;
  border-radius: 85.714px;

  ${media.xl`
    display: flex;
  `}
`;

export const NavList = styled.ul`
  display: none;
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
  padding: 0px;
  margin: 0;

  ${media.xl`
    gap: 10px;
  `}
`;

export const Item = styled.a`
  color: #f0f0f5;
  font-family: 'Satoshi Variable Medium', sans-serif;
  font-size: 17px;
  font-weight: 500;
  line-height: 110%;
  cursor: pointer;
  text-align: center;
  padding: 5px 11px;
  border-radius: 60px;
  background: #1c1c1c;

  &:hover {
    background: #f0f0f5;
    color: #1c1c1c;
  }
`;

export const BlankSpace = styled.div`
  margin: auto;
  display: flex;

  ${media.xl`
    display: none;
    margin: 0;
  `}
`;

export const DesktopContainer = styled.div`
  display: none;
  justify-content: end;
  align-items: center;
  gap: 10px;

  ${media.xl`
    display: flex;
    margin: 0px 0px 0px 10px;
  `}
`;

export const ResponsiveContainer = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  margin: 0px 0px 0px 8px;

  ${media.md`
    margin: 0px;
  `}

  ${media.lg`
    margin: 0px 0px 0px 12px;
  `}

  ${media.xl`
    display: none;
  `}
`;

export const LoginButtonDesktop = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ff9500;
  border-radius: 116.162px;
  padding: 5px 8px;
  gap: 2px;
  width: fit-content;
  height: 34px;
  color: #1c1c1c;
  font-family: 'Satoshi Variable Medium', sans-serif;
  font-size: 18px;
  font-weight: 500;
  line-height: 110%;
  text-align: center;
  cursor: pointer;
  box-shadow: 0 0 0 0 rgba(255, 149, 0, 0.5);
  border: none;

  position: relative;
  overflow: hidden;
  z-index: 1;
  transition: background 0.3s ease, color 0.3s ease;

  &:hover {
    background: #ff7c18;
  }

  .ripple {
    position: absolute;
    border-radius: 50%;
    transform: scale(0);
    animation: ripple-animation 1.5s ease-out;
    background-color: rgba(204, 85, 0, 0.6);
    pointer-events: none;
    z-index: 0;
  }

  @keyframes ripple-animation {
    to {
      transform: scale(4);
      opacity: 0;
    }
  }

  &.pulse:not(:hover) {
    animation: pulse 1.5s linear infinite;
  }

  @keyframes pulse {
    0% {
      transform: scale(0.9);
    }
    70% {
      transform: scale(1);
      box-shadow: 0 0 0 40px rgba(255, 149, 0, 0);
    }
    100% {
      transform: scale(0.9);
      box-shadow: 0 0 0 0 rgba(255, 149, 0, 0);
    }
  }
`;

export const LoginButton = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ff9500;
  border-radius: 116.162px;
  padding: 14px 28px;
  gap: 9.293px;
  width: 112px;
  height: 20px;
  color: #1c1c1c;
  font-family: 'Satoshi Variable Medium', sans-serif;
  font-size: 18px;
  font-weight: 500;
  line-height: 110%;
  text-align: center;
  cursor: pointer;

  position: relative;
  overflow: hidden;
  z-index: 1;
  transition: background 0.3s ease, color 0.3s ease;

  &:hover {
    background: #ff7c18;
  }

  .ripple {
    position: absolute;
    border-radius: 50%;
    transform: scale(0);
    animation: ripple-animation 1.5s ease-out;
    background-color: rgba(204, 85, 0, 0.6);
    pointer-events: none;
    z-index: 0;
  }

  @keyframes ripple-animation {
    to {
      transform: scale(4);
      opacity: 0;
    }
  }
`;

export const StyledSearch = styled(SearchBar)`
  button {
    width: 42px;
    height: 42px;
    display: grid;
    justify-content: center;
    align-items: center;

    #search {
      /* Additional styling if needed */
    }
  }

  ${media.md`
    margin-left: auto;
    margin-right: 12px;
  `}

  ${media.lg`
    margin-left: unset;
    margin-right: unset;
  `}

  input {
    display: none;

    width: 247px;

    ${media.md`
      width: 177px;
    `}

    ${media.lg`
      width: 0px;
    `}

    @media (min-width: 1024px) and (max-width: 1366px) {
      width: 177px;
    }

    &::placeholder {
      color: #757575;
      font-family: 'Satoshi Variable Medium', sans-serif;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
  }
`;

// Dropdown Components
export const DropdownContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

export const DropdownTrigger = styled.button<{ $isOpen: boolean }>`
  display: flex;
  align-items: center;
  gap: 4px;
  color: #f0f0f5;
  font-family: 'Satoshi Variable Medium', sans-serif;
  font-size: 17px;
  font-weight: 500;
  line-height: 110%;
  cursor: pointer;
  text-align: center;
  padding: 5px 11px;
  border-radius: 60px;
  background: #1c1c1c;
  border: none;
  transition: background 0.2s ease, color 0.2s ease;
  white-space: nowrap;

  &:hover {
    background: #f0f0f5;
    color: #1c1c1c;
  }

  ${({ $isOpen }) =>
    $isOpen &&
    css`
      background: #f0f0f5;
      color: #1c1c1c;
    `}
`;

export const DropdownMenu = styled.div<{ $isOpen: boolean }>`
  position: absolute;
  top: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  min-width: 200px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  padding: 8px 0;
  opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0)};
  visibility: ${({ $isOpen }) => ($isOpen ? 'visible' : 'hidden')};
  transition: opacity 0.2s ease, visibility 0.2s ease;
  z-index: 1000;
`;

export const DropdownItem = styled.a`
  display: block;
  padding: 10px 16px;
  font-family: 'Satoshi Variable Medium', sans-serif;
  font-size: 15px;
  font-weight: 500;
  color: #1c1c1c;
  text-decoration: none;
  transition: background-color 0.2s ease, color 0.2s ease;
  white-space: nowrap;

  &:hover {
    background: #f5f5f5;
    color: #ff9500;
  }

  &:last-child {
    border-top: 1px solid #e5e5e5;
    margin-top: 4px;
    padding-top: 14px;
  }
`;
